export default "__VITE_ASSET__xm5FQfP1__"